import { injectEndpoints } from '../../../../../../service/service';
import { addRole, listRoles } from './AccountSwitcher.types';

const AccountSwitcherEndpoints = injectEndpoints({
  endpoints: (builder) => ({
    listRoles: builder.query<listRoles[], void>({
      query: () => {
        return {
          method: 'GET',
          url: '/v2/role',
        };
      },
    }),
    addRole: builder.query<void, addRole>({
      query: (body: addRole) => {
        return {
          method: 'POST',
          url: '/v2/addRole',
        };
      },
    }),
  }),
});

export const { useListRolesQuery, useLazyListRolesQuery } = AccountSwitcherEndpoints;
